'use strict';

var d3 = require('d3');
var Tiles = function Tiles(d3Helper) {
  /**
   * @param xPropertyName - a property name used to find X value
   * @param yPropertyName - a property name used to find Y value
   * @param arrayPropertyName - an optional parameter indicating that the element provides an array of items to draw
   * @returns {Function}
   * @constructor
   */
  return function (xPropertyName, yPropertyName, arrayPropertyName) {
    var params, scales;
    var tileHeight = 10;
    var tiles = function tiles(container) {
      var tileWidth = scales.xScale.rangeBand();
      var domain = scales.yScale.domain();
      var yMin = scales.yScale(domain[1]);
      var yMax = scales.yScale(domain[0]);
      function isVisible(value) {
        return yMin <= value && value <= yMax;
      }
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        var tilesGroupElement = d3Helper.createGroupElement(d3.select(this), 'tiles-group');
        var tilesGroup = tilesGroupElement.selectAll('.tile').data(arrayPropertyName ? d[arrayPropertyName] : [d]);
        tilesGroup.enter().append('rect').attr({
          'height': tileHeight
        });
        tilesGroup.exit().remove();
        tilesGroup.attr({
          'data-tile-label': function dataTileLabel(d) {
            return d.tileLabel;
          },
          'class': function _class(d) {
            var className = ['tile'];
            if (typeof d.className !== 'undefined') {
              className.push(d.className);
            }
            return className.join(' ');
          },
          'y': function y(d) {
            var value = scales.yScale(d[yPropertyName]);
            return isVisible(value) ? value : -1000;
          },
          'width': tileWidth
        });
        if (params.isSparse) {
          tilesGroup.attr({
            'x': params.xBarPadding,
            'width': function width() {
              return params.xDataSize - params.xBarPadding * 2;
            }
          });
        }
        tilesGroup.style({
          'fill': function fill(d) {
            return d.fill;
          }
        });
      });
    };
    tiles.params = function (value) {
      params = value;
      return tiles;
    };
    tiles.withHeight = function (value) {
      tileHeight = value;
      return tiles;
    };
    tiles.scales = function (value) {
      scales = value;
      return tiles;
    };
    return tiles;
  };
};
Tiles.$inject = ['d3Helper'];
module.exports = Tiles;